import styled from "styled-components";

const P1 = styled.p`
  font-size: 16px;
  margin-bottom: 16px;
  line-height: 1.6;
  font-weight: 400;
  color: #000000;
`

export default P1